import React from "react";

function InfoCards() {
	return (
		<aside className='group-builder-info'>
			<div className='card card-info group-builder-info-card'>
				<div className='card-body'>
					<p className='groups-page-eyebrow text-primary mb-2'>Guia rapida</p>
					<h2 className='group-builder-info-title mb-3'>
						Elige la dinamica del grupo
					</h2>
					<p className='group-builder-info-copy mb-0'>
						Estas reglas ayudan a explicar rapido la experiencia antes de invitar
						a otros jugadores.
					</p>
				</div>
			</div>

			<div className='card card-info group-builder-info-card'>
				<div className='card-body'>
					<h3 className='group-builder-info-card-title'>Apuesta por ganador</h3>
					<p className='group-builder-info-copy'>
						El jugador elige ganador o empate. Es la opcion mas simple para
						grupos casuales.
					</p>
					<div className='group-builder-bullet'>
						<span className='group-builder-bullet-dot'></span>
						<span>
							Acertar ganador o empate suma <strong>+1 punto</strong>.
						</span>
					</div>
				</div>
			</div>

			<div className='card card-info group-builder-info-card'>
				<div className='card-body'>
					<h3 className='group-builder-info-card-title'>Apuesta por marcador</h3>
					<p className='group-builder-info-copy'>
						El jugador pronostica el marcador final. Da mas informacion y sube
						la competencia.
					</p>
					<div className='group-builder-bullet'>
						<span className='group-builder-bullet-dot'></span>
						<span>Acertar marcador local suma <strong>+1 punto</strong>.</span>
					</div>
					<div className='group-builder-bullet'>
						<span className='group-builder-bullet-dot'></span>
						<span>
							Acertar marcador visitante suma <strong>+1 punto</strong>.
						</span>
					</div>
					<div className='group-builder-bullet'>
						<span className='group-builder-bullet-dot'></span>
						<span>
							Acertar ganador o empate suma <strong>+1 punto</strong>.
						</span>
					</div>
				</div>
			</div>
		</aside>
	);
}

export { InfoCards };
